import SHARED_META from './shared'
import { SHARED_META_ZAVA } from './zava.shared'

export default {
  es_ES: {
    title: 'Inicia sesión en tu Área Personal - ZAVA España',
    meta: [
      ...SHARED_META,
      ...SHARED_META_ZAVA,
      {
        property: 'og:title',
        content: 'Inicia sesión en tu Área Personal - ZAVA España'
      },
      {
        property: 'og:description',
        content: 'ZAVA es un servicio médico online que te permite recibir tratamientos de médicos colegiados de forma rápida, segura y sin desplazarte.'
      },
      {
        property: 'og:url',
        content: 'https://www.zavamed.com/es/'
      },
      {
        property: 'og:image',
        content: 'https://www.zavamed.com/es/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'twitter:title',
        content: 'Inicia sesión en tu Área Personal - ZAVA España'
      },
      {
        name: 'twitter:description',
        content: 'ZAVA es un servicio médico online que te permite recibir tratamientos de médicos colegiados de forma rápida, segura y sin desplazarte.'
      },
      {
        name: 'twitter:image',
        content: 'https://www.zavamed.com/es/assets/images/social/zava_blue.jpg'
      },
      {
        name: 'msapplication-TileImage',
        content: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/ms-icon-144x144.png'
      }
    ],
    link: [
      {
        rel: 'apple-touch-icon',
        sizes: '57x57',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-57x57.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '60x60',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-60x60.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '72x72',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-72x72.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '76x76',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-76x76.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '114x114',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-114x114.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '120x120',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-120x120.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '144x144',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-144x144.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '152x152',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-152x152.png'
      },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/apple-icon-180x180.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/android-icon-192x192.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/favicon-32x32.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '96x96',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/favicon-96x96.png'
      },
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: 'https://www.zavamed.com/es/assets/dist/images/favicons/zava/favicon-16x16.png'
      }
    ]
  }
}
